import { render, staticRenderFns } from "./VirtualBackgroundModal.vue?vue&type=template&id=b3c99bc6&scoped=true&"
import script from "./VirtualBackgroundModal.vue?vue&type=script&lang=js&"
export * from "./VirtualBackgroundModal.vue?vue&type=script&lang=js&"
import style0 from "./VirtualBackgroundModal.vue?vue&type=style&index=0&id=b3c99bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c99bc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3c99bc6')) {
      api.createRecord('b3c99bc6', component.options)
    } else {
      api.reload('b3c99bc6', component.options)
    }
    module.hot.accept("./VirtualBackgroundModal.vue?vue&type=template&id=b3c99bc6&scoped=true&", function () {
      api.rerender('b3c99bc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/VirtualBackgroundModal.vue"
export default component.exports